<template>
  <card>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="false"
      :itemLink="itemLink"
      :dateFilter="dateFilter"
      :setLink="setLink"
      :fields="fields"
      :filters="filters"
      :staticFilters="staticFilters"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :exportsData="exportsData"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      dateFilter: [
        {
          key: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          title: "Конец даты",
        },
      ],
      filters: [
        {
          key: "status_order",
          title: "Статус заказа",
          titleKey: "title",
        },
        {
          key: "dealer",
          title: "Бизнес",
          titleKey: "llc_name",
        },
        {
          key: "user",
          title: "Торговый представитель",
          titleKey: "name",
          params: { role_code: "tp_admin" },
        },
      ],
      staticFilters: [
        {
          title: "Статус оплаты",
          key: "is_paid",
          default: null,
          items: [
            {
              id: null,
              title: "Показать все",
            },
            {
              id: "2",
              title: "Оплачен",
            },
            {
              id: "1",
              title: "Не оплачен",
            },
          ],
        },
      ],
      val: [],
      modalCreate: "order",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "status",
          label: "Статус",
          type: "select",
          modal: "status_order",
        },
        {
          col: " col-12 col-md-12",
          key: "dealer",
          label: "Пользователь",
          type: "select",
          selectKey: "phone",
          modal: "dealer",
          params: {},
          toParametr: {
            key: "shop",
            parametr: "dealer_id",
            type: null,
          },
        },
        {
          col: " col-12 col-md-12",
          key: "shop",
          label: "Магазин",
          type: "select",
          selectKey: "name",
          modal: "shop",
          params: {},
        },
      ],
      exportsData: [
        {
          type: "export-all",
          url: '/orders/export-all',
          name: 'Заказы'
        }
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_order",
      itemLink: "orders",
      setLink: "orders",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy: "id",
        },

        {
          key: "dealer",
          object: "full_name",
          title: "Заказчик",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "dealer",
          object: "llc_name",
          title: "Организация",
          checkbox: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "dealer",
          object: "phone",
          title: "Номер телефона",
          checkbox: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "user",
          object: "name",
          title: "Представитель",
          checkbox: false,
          control: false,

          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "attach_users",
          object: "name",
          title: "Супервайзер",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          disableLink: true,
        },

        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },

        {
          key: "is_paid",
          title: "Оплачен",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "status",
          object: "title",
          title: "Статус",
          disableLink: true,
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
